<template>
    <div class="info-agent" v-if="agent && (agent.firstName || agent.lastName)">
        <AgentHeadShot :agent="agent" :class="['agent-image', `md-form-info-agent-${dataid}`]" />
        <div v-if="agent.firstName || agent.lastName" class="agent-detail">
            <p class="name">
                {{ agent.firstName || '' }} {{ agent.lastName || '' }}
            </p>
            <template v-if="styleType === 'v2'">
                <p v-if="agent.phone" class="phone">
                    <a
                        :href="'tel:' + agent.phone"
                        target="_top"
                        rel="noopener noreferrer"
                    >
                        <i class="iconfont icon-phone-round"></i>
                        <span>{{ $ft.formatPhone(agent.phone) }}</span>
                    </a>
                </p>
                <p class="position mobile">
                    {{ agent.position || ''
                    }}{{ agent.position && agent.license ? ' | ' : '' }}
                    <span
                        v-if="agent.license"
                    >{{ licenseName }}{{ agent.license }}</span>
                </p>
                <p class="position">
                    <span v-if="agent.position">{{ agent.position }}</span>
                    <span
                        v-if="agent.license"
                    >{{ licenseName }}{{ agent.license }}</span>
                </p>
            </template>
            <template v-else-if="styleType === 'v3'">
                <p class="position">
                    {{ agent.position || ''
                    }}{{ agent.position && agent.license ? ' | ' : '' }}
                    <span
                        v-if="agent.license"
                    >{{ licenseName }}{{ agent.license }}</span>
                </p>
                <p v-if="agent.phone" class="phone">
                    <a
                        :href="'tel:' + agent.phone"
                        target="_top"
                        rel="noopener noreferrer"
                    >{{ $ft.formatPhone(agent.phone) }}</a>{{ agent.phone && agent.email ? ' | ' : '' }}{{ agent.email }}
                </p>
            </template>
            <template v-else>
                <p class="position">
                    {{ agent.position || ''
                    }}{{ agent.position && agent.license ? ' | ' : '' }}
                    <span
                        v-if="agent.license"
                    >{{ licenseName }}{{ agent.license }}</span>
                </p>
                <p v-if="agent.phone" class="phone">
                    <a
                        :href="'tel:' + agent.phone"
                        target="_top"
                        rel="noopener noreferrer"
                    >{{ $ft.formatPhone(agent.phone) }}</a>
                </p>
            </template>
        </div>
    </div>
</template>

<script>
import util from '@/common/util';
import AgentHeadShot from "@/components/agent-headshot.vue"
export default {
    props: {
        agent: {
            type: Object,
            required: true
        },
        licenseName: {
            type: String,
            required: true
        },
        styleType: {
            type: String,
            default: 'v1'
        }
    },
    components: {
        AgentHeadShot
    },
    data: function() {
        return {
            dataid: util.uuidv4(),
        }
    }
};
</script>
